import NotificationsIcon from '@mui/icons-material/Notifications';
import { ReactElement } from 'react';
import {
  BulkDeleteWithConfirmButton,
  Datagrid,
  DateField,
  List,
  ReferenceField,
  SearchInput,
  TextField,
  useRecordContext,
} from 'react-admin';

// Icon for NotificationDetail resource
export const NotificationDetailIcon = NotificationsIcon;

// Function that returns an array of filters in react admin
const getNotificationDetailFilters = (): ReactElement[] => {
  const filters = [<SearchInput source="notification_id,payload,tokens" alwaysOn />];
  return filters.filter((filter) => filter !== null) as ReactElement[];
};

const NotificationDetailBulkActionButtons = (props: any) => <BulkDeleteWithConfirmButton {...props} />;

// Custom status field component to map status values to labels
const NotificationStatusField = () => {
  const record = useRecordContext();
  if (!record || record.status === undefined) return null;

  const statusMap: Record<number, { label: string; color: string }> = {
    0: { label: 'Pending', color: '#FFC107' }, // Yellow for pending
    1: { label: 'Processing', color: '#2196F3' }, // Blue for processing
    2: { label: 'Sent', color: '#4CAF50' }, // Green for sent
    3: { label: 'Failed', color: '#F44336' }, // Red for failed
  };

  const status = statusMap[record.status] || { label: `Unknown (${record.status})`, color: '#9E9E9E' };

  return (
    <div
      style={{
        backgroundColor: status.color,
        color: 'white',
        borderRadius: '16px',
        padding: '3px 8px',
        fontSize: '0.8125rem',
        display: 'inline-block',
        fontWeight: 500,
      }}
    >
      {status.label}
    </div>
  );
};

export const NotificationDetailList = () => {
  return (
    <List filters={getNotificationDetailFilters()} sort={{ field: 'created_at', order: 'DESC' }}>
      <Datagrid bulkActionButtons={<NotificationDetailBulkActionButtons />} rowClick="show">
        <TextField source="id" />
        <ReferenceField source="notification_id" reference="notifications">
          <TextField source="title" />
        </ReferenceField>
        <TextField
          source="tokens"
          sortable={false}
          render={(record: any) => (record.tokens ? record.tokens.substring(0, 30) + '...' : '')}
        />
        <NotificationStatusField />
        <DateField source="created_at" showTime />
      </Datagrid>
    </List>
  );
};

export default NotificationDetailList;
